import { Box, Container, Typography, Tab, Tabs, Grid } from "@mui/material";
import { motion } from "framer-motion";
import { useState } from "react";
import { ProjectCard } from "../components/ProjectCard";
import { projects } from "../data/projects";
import { fadeIn, staggeredContainer } from "../utils/animations";

const categories = ["All", "Web Apps", "Mobile", "Open Source"];

export const Work = () => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  return (
    <Box
      component="main"
      sx={{
        py: 8,
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Container maxWidth="lg">
        <motion.div variants={fadeIn} initial="hidden" animate="visible">
          <Typography
            variant="h1"
            gutterBottom
            sx={{
              fontSize: { xs: "2.5rem", md: "3.5rem" },
              fontWeight: 700,
              mb: 3,
            }}
          >
            My Work
          </Typography>
          <Typography
            variant="h5"
            color="text.secondary"
            paragraph
            sx={{ mb: 6 }}
          >
            A collection of my recent projects and contributions
          </Typography>

          <Box sx={{ mb: 6 }}>
            <Tabs
              value={activeTab}
              onChange={handleTabChange}
              variant="scrollable"
              scrollButtons="auto"
              textColor="primary"
              indicatorColor="secondary"
              sx={{ borderBottom: 1, borderColor: "divider" }}
            >
              {categories.map((category) => (
                <Tab key={category} label={category} sx={{ fontWeight: 500 }} />
              ))}
            </Tabs>
          </Box>

          <motion.div
            variants={staggeredContainer}
            initial="hidden"
            animate="visible"
            viewport={{ margin: "-100px" }}
          >
            <Grid container spacing={2}>
              {projects
                .filter((p) =>
                  categories[activeTab] === "All"
                    ? p
                    : p.type === categories[activeTab]
                )
                .map((project, index) => (
                  <Grid item xs={12} md={6} key={project.title}>
                    <ProjectCard {...project} index={index} />
                  </Grid>
                ))}
            </Grid>
          </motion.div>
        </motion.div>
      </Container>
    </Box>
  );
};

export default Work;
